<script>
import { mapActions } from 'vuex';
import { snapToPenaltyChangeDay } from './tax-common.util';

// Shared by GeneralDetailsForm/CreateSAForm/CreateOmitForm - all three have a Penalty Start
// Date field that must land on the county's penalty change day. Host component must expose
// `taxSettingItem` and `editedItem`.
export default {
  methods: {
    ...mapActions([
      'flashInfo',
    ]),
    penaltyStartDateOnBlurred(val) {
      const { penaltyDate } = this.taxSettingItem;
      if (!val || !penaltyDate) return;
      const { value, snapped, landedDay } = snapToPenaltyChangeDay(val, penaltyDate);
      this.editedItem.penaltyStartDate = value;
      if (snapped) {
        this.flashInfo(`Penalty Start Date adjusted to the penalty change day (${landedDay})`);
      }
    },
  },
};
</script>
